import { TableFieldModel } from '@/model/TableList'

export const TableField: TableFieldModel[] = [
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'name',
    fieldName: '菜单名称'
  }, {
    componentType: 'el-iconfont',
    componentName: '输入框',
    fieldKey: 'icon',
    fieldName: '菜单图标'
  }, {
    componentType: 'el-select',
    componentName: '输入框',
    fieldKey: 'type',
    fieldName: '菜单类型',
    selectType: 3,
    width: 70,
    option: [
      { name: '菜单', id: 1 },
      { name: '按钮', id: 2 }
    ]
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'order',
    fieldName: '排序',
    width: 50
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'path',
    fieldName: '路由地址',
    width: 170
  }, {
    componentType: 'el-select',
    componentName: '下拉选择',
    fieldKey: 'method',
    fieldName: '请求方法',
    url: 'HttpMethodType',
    selectType: 1,
    width: 80
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'url',
    fieldName: '后端页面路径'
  }
]
